import { Dispatch, SetStateAction } from 'react';
import { ICycleCoefficient, ICycleMatiere, ICycleScoringMode, ICycleSousMatiere } from 'app/entities/cycle/cycle.reducer';
import { IClasse } from 'app/shared/model/classe.model';
import { ICycle } from 'app/shared/model/cycle.model';

export const KORI_ORANGE = '#f59b42';
export const TMP_PREFIX = 'tmp-';

export type RowStatus = 'existing' | 'new';

export interface CycleRow extends Omit<ICycle, 'id'> {
  id: string;
  localId: string;
  status: RowStatus;
}

export interface ClasseRow extends Omit<IClasse, 'id'> {
  id: string;
  localId: string;
  originalCycleId?: string | null;
  status: RowStatus;
}

export interface MatiereRow extends ICycleMatiere {
  localId: string;
  cycleId: string;
  matiereId?: string;
  status: RowStatus | 'link' | 'update';
  deleted?: boolean;
}

export interface SousMatiereRow extends ICycleSousMatiere {
  localId: string;
  status: RowStatus;
  deleted?: boolean;
}

export type CycleMatieresState = Record<string, MatiereRow[]>;
export type SousMatieresState = Record<string, SousMatiereRow[]>;
export type CoefficientsState = Record<string, Record<string, number | null>>;
export type CoefficientsByMatiereState = Record<string, Record<string, ICycleCoefficient>>;
export type ScoringModesByCycleState = Record<string, ICycleScoringMode>;

export type SetCycleMatieres = Dispatch<SetStateAction<CycleMatieresState>>;
export type SetSousMatieres = Dispatch<SetStateAction<SousMatieresState>>;
export type SetCoefficients = Dispatch<SetStateAction<CoefficientsState>>;
export type SetClasses = Dispatch<SetStateAction<ClasseRow[]>>;

export const normalize = (value?: string | null) => (value || '').trim().toLocaleLowerCase();
export const tmpId = () => `${TMP_PREFIX}${Date.now()}-${Math.random().toString(16).slice(2)}`;
export const pairKey = (cycleId: string, matiereId: string) => `${cycleId}:${matiereId}`;
